import portfolio1 from '../assets/images/freelancer/1.jpg'
import portfolio2 from '../assets/images/freelancer/2.jpg'
import portfolio3 from '../assets/images/freelancer/3.jpg'
import portfolio4 from '../assets/images/freelancer/4.jpg'
import portfolio5 from '../assets/images/freelancer/5.jpg'
import portfolio6 from '../assets/images/freelancer/6.jpg'

export const skillData = [
    {
        title:'WordPress',
        value:'84%',
        bg:'bg-warning'
    },
    {
        title:'English',
        value:'84%',
        bg:'bg-primary'
    },
    {
        title:'PHP / MYSQL',
        value:'75%',
        bg:'bg-info'
    },
    {
        title:'Portuguese',
        value:'75%',
        bg:'bg-primary'
    },
    {
        title:'Angular / JavaScript',
        value:'79%',
        bg:'bg-primary'
    },
    {
        title:'Spanish',
        value:'79%',
        bg:'bg-danger'
    },
    {
        title:'HTML',
        value:'95%',
        bg:'bg-success'
    },
    {
        title:'German',
        value:'95%',
        bg:'bg-info'
    },
]

export const servicesData = [
    {
        icon:'mdi mdi-layers-triple-outline',
        title:'UX / UI Design',
        desc:"The most well-known dummy text is the 'Lorem', which well-known is said which is said to have in."
    },
    {
        icon:'mdi mdi-responsive',
        title:'Ios App Designer',
        desc:"One disadvantage of Lorum Ipsum is that in certain letters which is said appear more than."
    },
    {
        icon:'mdi mdi-camera',
        title:'Photography',
        desc:"Moreover, in Latin only words at the beginning of sentences which is said are capitalized."
    },
    {
        icon:'mdi mdi-lightbulb-outline',
        title:'Graphic Designer',
        desc:"If the fill text is intended to illustrate the characteristics well-known which is said of sometimes."
    },
    {
        icon:'mdi mdi-account-heart-outline',
        title:'Customer Care',
        desc:"There is now an abundance of readable dummy texts. These are which well-known is said text is."
    },
    {
        icon:'mdi mdi-google',
        title:'Web Security',
        desc:"These alternatives to the classic are often amusing and tell short, which is said stories."
    },
]

export const faqData = [
    {
        id:1,
        title:'Senior Developer (3 Years)',
        name:'Google ltd.',
        year:'2015-2018',
        desc:"Faff about only a quid blower I don’t want no agro bleeding chimney pot burke tosser cras nice one boot fanny.! There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form."
    },
    {
        id:2,
        title:'Web Designer (2 Years)',
        name:'Vivo ltd.',
        year:'2013-2015',
        desc:"There are many variations of Faff about only a quid blower I don’t want no agro bleeding chimney pot burke tosser cras nice one boot fanny.! passages of Lorem Ipsum available, but the majority have suffered alteration in some form."
    },
    {
        id:3,
        title:'Web Designer (2 Years)',
        name:'Oppo ltd.',
        year:'2010-2013',
        desc:"There are many variations of passages of Lorem Ipsum available, Faff about only a quid blower I don’t want no agro bleeding chimney pot burke tosser cras nice one boot fanny.! but the majority have suffered alteration in some form."
    },
]

export const portfolioData = [
    {
        image:portfolio1,
        name:'Shifting Perspective',
        title:'Studio'
    },
    {
        image:portfolio2,
        name:'Colors Magazine',
        title:'Web Design'
    },
    {
        image:portfolio3,
        name:'Spa Cosmetics',
        title:'Developing'
    },
    {
        image:portfolio4,
        name:'Riser Coffee',
        title:'Branding'
    },
    {
        image:portfolio5,
        name:'Dancing With Myself',
        title:'Photography'
    },
    {
        image:portfolio6,
        name:'New trends in SEO',
        title:'Business'
    },
]

export const portfolioImages = [portfolio1,portfolio2,portfolio3,portfolio4,portfolio5,portfolio6]